export const siteLogo = {
    logo: "assets/images/dorcaslaboy.png",  // Add your site logo here
    alt: "Dorcas Laboy"  // Add your site name here
};
export const socialLink = {
    facebook: "https://www.facebook.com/DorcasLaboy/",
    instagram: "https://www.instagram.com/dorcaslaboy",
    tiktok: "https://www.tiktok.com/@dorcaslaboy",
    youtube: "https://www.youtube.com/dorcaslaboy",
};
export const mailchimpLink = {
    link: (process.env.REACT_APP_MAILCHAIMP) // Add your mailchimp list link here
};
export const contactFormAction = {
    link: (process.env.REACT_APP_CONTACTFORM)  // Add for link here from https://formspree.io
}
export const contactMap = {
    link: (process.env.REACT_APP_CONTACTMAP) // Add google map link from here: https://www.embedgooglemap.net/
}
